module.exports = __webpack_public_path__ + "static/media/bnp paribas.8985d497.svg";